import * as React from 'react';
import { useDispatch } from 'react-redux';
import { ModalContainer } from '@moovly/ui';
import { t } from '@moovly/i18n';
import { revokeLicense } from '../../subscriptions/store/licenses.store';
import { LicenseData } from '../../subscriptions/types/licenses';
import { DefaultModalProps } from '../../../types/modal';

export interface RevokeLicenseModalProps extends DefaultModalProps {
  license: LicenseData;
}

export const RevokeLicenseModal: React.FC<RevokeLicenseModalProps> = ({ license, closeModal, setOpen }) => {
  const dispatch = useDispatch<any>();
  const handleConfirm = React.useCallback(() => {
    if (!!license)
      dispatch(
        revokeLicense({
          contractId: license.contract.id,
          licenseId: license.id,
        })
      );
    closeModal();
  }, [dispatch, closeModal, license]);

  return (
    <ModalContainer
      title={license?.assignments_left ? t('revokeModal.default.title') : t('revokeModal.lastAssignment.title')}
      description={
        license?.assignments_left ? t('revokeModal.default.description') : t('revokeModal.lastAssignment.description')
      }
      confirmButtonText={t('actions.revoke')}
      onConfirm={handleConfirm}
      isOpen={!!license}
      onClose={closeModal}
      setOpen={setOpen}
    />
  );
};

export default RevokeLicenseModal;
